// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jiUBv","inner":"Header_inner__jb7a0","logo":"Header_logo__shVBB","buttons":"Header_buttons__qrm31"};